var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236",
    transform: "translate(-673 -412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168",
    transform: "translate(-17.164 -73.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    transform: "translate(690.164 485.279)",
    fill: "none",
    stroke: "#142e38",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 10.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(678 416.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box",
    transform: "translate(0 0.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 13,
    height: 13,
    transform: "translate(0 0.092)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons",
    transform: "translate(0.978 0.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M7.609,18.578a1.692,1.692,0,0,1,2.369,0,.564.564,0,0,0,.79-.79,2.764,2.764,0,0,0-3.949,0L4.788,19.819a2.764,2.764,0,0,0,0,3.949,2.792,2.792,0,0,0,3.949,0l1.269-1.326a.564.564,0,0,0-.79-.79L7.947,22.978a1.675,1.675,0,1,1-2.369-2.369Z",
    transform: "translate(-3.82 -13.153)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M5.762,13.275a.564.564,0,0,0,.762-.254.536.536,0,0,0-.226-.733l-2-1.044a.564.564,0,0,0-.762.254.536.536,0,0,0,.226.733Z",
    transform: "translate(-3.468 -9.007)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M13.288,6.3a.536.536,0,0,0,.733.226.564.564,0,0,0,.254-.762l-1.044-2a.536.536,0,0,0-.733-.226.564.564,0,0,0-.254.762Z",
    transform: "translate(-9.725 -3.468)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M35.793,29.919l-2-1.015a.564.564,0,1,0-.508.987l2,1.044a.568.568,0,1,0,.508-1.015Z",
    transform: "translate(-24.586 -21.645)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M28.891,33.282a.564.564,0,1,0-.987.508l1.015,2a.568.568,0,1,0,1.015-.508Z",
    transform: "translate(-20.927 -24.586)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M23.1,6.934l1.269-1.326a1.675,1.675,0,1,1,2.369,2.369L25.021,9.7l.79.79,1.721-1.721a2.792,2.792,0,1,0-3.949-3.949L22.313,6.144a.564.564,0,0,0,.79.79Z",
    transform: "translate(-16.916 -3.85)",
    fill: "#142e38"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinking);
export default __webpack_public_path__ + "static/media/linking.1689b40477eed03d8f4cdacc46411211.svg";
export { ForwardRef as ReactComponent };